import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Text,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import * as T from '../../components/Table'

export function HistoricoPedido({ historico, statusAtual }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  console.log(historico)

  const historicoClean = historico?.map((item) => {
    return {
      data_status: item['Data do status'] ? format(new Date(item['Data do status']), 'dd/MM/yyyy HH:mm') : '-',
      status: item.Status,
      observacao: item.Observação,
    }
  })

  return (
    <>
      <Button onClick={onOpen} size="xs" colorScheme="blue" variant="outline">
        Ver Histórico
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Histórico do Pedido</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={2} px={2} py={1} bg="gray.100" borderRadius="md" display="inline-block" color="gray.800" fontSize="sm" fontWeight="semibold">
              Status atual: <strong>{statusAtual}</strong>
            </Text>
            <T.Table>
              <T.Thead>
                <T.Tr>
                  <T.Th>Data</T.Th>
                  <T.Th>Status</T.Th>
                  <T.Th>Observação</T.Th>
                </T.Tr>
              </T.Thead>
              <T.Tbody>
                {historicoClean?.map((item, index) => (
                  <T.Tr key={index}>
                    <T.Td>{item.data_status}</T.Td>
                    <T.Td>{item.status}</T.Td>
                    <T.Td>{item.observacao}</T.Td>
                  </T.Tr>
                ))}
              </T.Tbody>
            </T.Table>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
